import { encrypt } from '@/common/securityUtils';
import { Form, useForm } from '@/components/forms';
import { Button } from '@/design-system/button';
import { Translation } from '@/hoslog-intl/Translation.tsx';
import { FileObject, uploadFileToS3WithPresignedUrl } from '@/lib/uploadToAWS';
import { useParams } from '@tanstack/react-router';
import { addHostFormSchema } from '../../basic-stores/schema/host-form.schema';
import { buildHostPayload } from '../../basic-stores/utils/buildHostPayload';
import { PersonalInfo } from '../../PersonalInfo';
import { SkillsSet } from '../../SkillsSet';
import { SNS } from '../../Sns';
import useAddHostInfo from '../hooks/useAddHostInfo';
import { useAvailableRankOptions } from '../hooks/useAvailableRankOptions';

export const AddHost = () => {
  const { mutateAsync } = useAddHostInfo();
  const form = useForm({
    schema: addHostFormSchema,
    mode: 'onBlur',
    defaultValues: {
      hostName: '',
      furigana: '',
      profileImage: '',
      dobYear: '',
      dobMonth: '',
      dobDay: '',
      position: '',
      rank: encrypt('0'),
      height: '',
      instagram: '',
      tiktok: '',
      line: '',
      twitter: '',
      website: '',
      mbti: '',
      title: '',
      skills_appearance: '3',
      skills_conversationStyle: '3',
      skills_alcoholTolerance: '3',
      skills_atmosphere: '3',
    },
  });

  const { clubid: clubId } = useParams({
    from: '/(app)/store-information/premium-stores/host-management/$clubid/add-host',
  });
  const rankOptions = useAvailableRankOptions(clubId);

  const handleSubmit = async () => {
    const formData = form.getValues();
    let profileImageUrl = '';
    if (formData.profileImage) {
      profileImageUrl = await uploadFileToS3WithPresignedUrl(formData.profileImage as FileObject);
    }
    const payload = buildHostPayload({
      clubId: clubId || '',
      formData,
      profileImageUrl: profileImageUrl || '',
    });
    await mutateAsync(payload);
  };

  return (
    <div className="rounded-lg bg-card shadow-panel p-8">
      <Form form={form} onSubmit={handleSubmit}>
        <PersonalInfo rankOptions={rankOptions} />
        <SNS storeOrHost="host" />
        <SkillsSet />
        <div className="border-t-2 border-t-muted pt-6 flex flex-row-reverse w-full gap-4 text-sm mt-6 justify-between">
          <Button type="submit" className="w-[110px]">
            <Translation id="common.page.button.submit" />
          </Button>
          <Button type="button" variant="outline" className="w-[122px]" onClick={() => window.history.back()}>
            <Translation id="common.page.button.cancel" />
          </Button>
        </div>
      </Form>
    </div>
  );
};
